// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"625":"8d415a29","762":"df0944c8"}[chunkId] + ".chunk.css";
};